import React from 'react';
import PropTypes from 'prop-types';
// components
import NumberFormat from 'react-number-format';

/**
 * @deprecated Use Telerik or shared components instead.
 */
const SSNInput = ({
  value, disabled, onChange, onBlur, ...inputProps
}) => (
  <NumberFormat
    {...inputProps}
    onChange={onChange}
    onBlur={onBlur}
    value={value}
    format='###-##-####'
    disabled={disabled}
  />
);

SSNInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

export default SSNInput;
